@if (relatedByCategory?.length > 0 || relatedByDistance?.length > 0) {
  <div class="relatedEvents">
    <!-- StreApps in de buurt-->
    @if (relatedByDistance?.length > 0) {
      <div class="subEvents">
        <h1 class="title" [title]="'page.detail.related_event.title_distance' | translate"><span>{{'page.detail.related_event.title_distance' | translate}}</span></h1>
        <div class="events-container">
          @for (relatedEvent of relatedByDistance; track relatedEvent) {
            <a routerLink="/detail/{{relatedEvent.partitionKey}}" class="cardLink">
              <image-block
                [thumbnail]="relatedEvent.thumbnail"
                [hoverText]="relatedEvent.title"
                [category]="relatedEvent.category"
                [created]="relatedEvent.created"
              ></image-block>
            </a>
          }
        </div>
      </div>
    }
    <!-- StreApps van dezelfde categorie -->
    @if (relatedByCategory?.length > 0) {
      <div class="subEvents">
        <h1 class="title" [title]="'page.detail.related_event.title_category' | translate"><span>{{'page.detail.related_event.title_category' | translate}}</span></h1>
        <div class="events-container">
          @for (relatedEvent of relatedByCategory; track relatedEvent) {
            <a routerLink="/detail/{{relatedEvent.partitionKey}}" class="cardLink">
              <image-block
                [thumbnail]="relatedEvent.thumbnail"
                [hoverText]="relatedEvent.title"
                [category]="relatedEvent.category"
                [created]="relatedEvent.created"
              ></image-block>
            </a>
          }
        </div>
      </div>
    }
  </div>
}
